import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { TextTitle } from '@/types/textTitle'

export const useTextTitleStore = defineStore('textTitleStore', () => {
  const povTitle = ref<TextTitle>()
  function initTitle() {
    povTitle.value = {
      x: 0,
      y: 0,
      text: '',
      width: 36 * 10,
      height: 36 * 2,
    }
  }
  function updateTitlePosition(x: number, y: number) {
    if (povTitle.value) {
      console.debug('updateTitlePosition', x, y)
      povTitle.value.x = x
      povTitle.value.y = y
    }
  }

  function updateTitleText(text: string) {
    if (povTitle.value) {
      console.debug('updateTitleText', text)
      povTitle.value.text = text
    }
  }

  function updateTitleSize(width: number, height: number) {
    if (povTitle.value) {
      console.debug('updateTitleSize', width, height)
      povTitle.value.width = width
      povTitle.value.height = height
    }
  }
  function deleteTitle() {
    povTitle.value = undefined
  }

  function reset() {
    povTitle.value = undefined
  }

  return {
    povTitle,
    initTitle,
    updateTitlePosition,
    updateTitleText,
    updateTitleSize,
    deleteTitle,
    reset,
  }
})
